/**
 * @dd/ui-tokens — design tokens deco-noir de ArgOS.
 *
 * La fuente de verdad son las custom properties de `tokens.css`; este módulo
 * re-exporta los nombres para consumo tipado desde TS. Los temas por época (B9)
 * redefinen las mismas variables — el código TS no cambia.
 */

export const palette = {
  carbon: "var(--carbon)",
  grafito: "var(--grafito)",
  papel: "var(--papel)",
  tinta: "var(--tinta)",
  laton: "var(--laton)",
  carmin: "var(--carmin)",
  billar: "var(--billar)",
  humo: "var(--humo)",
} as const;

export const font = {
  display: "var(--font-display)",
  ui: "var(--font-ui)",
  mono: "var(--font-mono)",
} as const;

export const space = {
  1: "var(--space-1)",
  2: "var(--space-2)",
  3: "var(--space-3)",
  4: "var(--space-4)",
  5: "var(--space-5)",
  6: "var(--space-6)",
} as const;

export const radius = {
  1: "var(--radius-1)",
  2: "var(--radius-2)",
  3: "var(--radius-3)",
} as const;

export const motion = {
  durWindow: "var(--dur-window)",
  durToast: "var(--dur-toast)",
  easeOut: "var(--ease-out)",
} as const;

export type PaletteToken = keyof typeof palette;
